export default __webpack_public_path__ + "static/media/IMG_1463.9a7a15cb.jpg";